var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SJCollapseTransition',_vm._g({attrs:{"duration":_vm.duration,"timingFunction":_vm.timingFunction}},_vm.$listeners),[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.value),expression:"value"}]},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }